export default {"src":"/_next/static/media/wheel_spin_outer.1c01028b.gif","height":900,"width":900};